/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


$(document).ready(function() {

  $('[data-fancybox="images"]').fancybox({
    afterLoad : function(instance, current) {
      var pixelRatio = window.devicePixelRatio || 1;

      if ( pixelRatio > 1.5 ) {
        current.width  = current.width  / pixelRatio;
        current.height = current.height / pixelRatio;
      }
    }
  });
  console.log('fdsf');
  $(document).on('click', '.bv_button_buttonFull', function(){
    //console.log('da');
    //console.log($(document).find('.description_tab .tabs'));
    $(document).find('.description_tab .tabs').find('li:eq(1)').find('a').trigger('click');
    //$(document).find('#tab-review').
    var h = ($("#tab-review").offset().top) - 150;
    $('html, body').animate({
      scrollTop: h
    }, 1000);
  });
});


$(document).ready(function() {

  $(".fancybox-effects-a").fancybox({
    helpers: {
      title : {
        type : 'outside'
      },
      overlay : {
        speedOut : 0
      }
    }
  });
});






jQuery( document ).ready(function( $ ){

  var cookie = getCookie('isSubscribe');

  if(cookie == null || cookie == 'undefined'){
    setTimeout(function() {$.blockUI({ message: $('#question'), css: { width: '275px' },onOverlayClick: $.unblockUI  })}, 7000);
  }

  $('#close-btn').click(function() { 
    $.unblockUI(); 
     setCookie('isSubscribe', true, 2);
  });


}); 



function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
  console.log(cname + "=" + cvalue + "; " + expires);
}
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  console.log(decodedCookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}


 